export default __webpack_public_path__ + "static/media/slot19.7ae75eee.png";